import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Button, TextField, Alert } from '@mui/material';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const GetUserId = () => {
  const [user, setUser] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  const copyToClipboard = () => {
    if (user) {
      navigator.clipboard.writeText(user.uid)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 3000);
        })
        .catch(err => {
          console.error('Failed to copy: ', err);
        });
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom align="center">
          Get Your User ID
        </Typography>
        
        {user ? (
          <>
            <Typography variant="body1" paragraph>
              You are currently signed in as: <strong>{user.email}</strong>
            </Typography>
            
            <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
              <Typography variant="h6">Your User ID:</Typography>
              <TextField
                fullWidth
                value={user.uid}
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
                variant="outlined"
              />
              
              <Button 
                variant="contained" 
                color="primary"
                onClick={copyToClipboard}
                sx={{ mt: 2 }}
              >
                Copy to Clipboard
              </Button>
              
              {copied && (
                <Alert severity="success" sx={{ mt: 2 }}>
                  User ID copied to clipboard!
                </Alert>
              )}
            </Box>
            
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6">Next Steps:</Typography>
              <ol>
                <li>Copy your User ID shown above</li>
                <li>Go to <a href="/marketplace/quick-admin">/marketplace/quick-admin</a></li>
                <li>Paste your User ID in the form</li>
                <li>Click "Make Super Admin"</li>
              </ol>
            </Box>
          </>
        ) : (
          <Alert severity="warning">
            You are not currently signed in. Please sign in to get your User ID.
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default GetUserId;
